import type { WidgetMessages } from '../types/widgetMessages';

// Английский справочник фраз
export const WIDGET_MESSAGES_EN: WidgetMessages = {
  errors: {
    rateLimit: 'Too many requests',
    rateLimitFiles: 'Exceeded file upload limit',
    rateLimitMessages: 'Exceeded message send limit',
    fileUploadCount: (maxFiles: number) => `Can attach no more than ${maxFiles} files to message`,
    fileUploadSize: (maxMb: number) => `Files larger than ${maxMb} MB won't be attached to message`,
    fileUploadAll: (maxFiles: number, maxMb: number) =>
      `Can attach no more than ${maxFiles} files to message, each no larger than ${maxMb} MB`,
  },
  phone: {
    overlayTitle: 'Enter number',
    overlayContinue: 'Continue',
    overlayCancel: 'Cancel',
    overlaySubtitle: 'linked to your MAX messenger account',
    overlayBackAria: 'Back',
    selectCountryCode: 'Select country code',
    selectCountry: 'Select country',
    empty: 'Enter phone number',
    minLength: (minLength: number) => `Phone number must be at least ${minLength} digits long`,
    invalidFormat: 'Invalid number format',
  },
  chat: {
    you: 'You',
    placeholder: 'Write message…',
    startChatTitle: 'Start chat',
    startChatDescription: "Describe your issue and we'll try to help",
    messageNotSent: 'Failed to send message',
    loadHistory: 'Message history',
    rateAnswerTitle: 'Rate reply',
    rateAnswerOf: 'of',
  },
  attach: {
    photoFromDevice: 'Photo from device',
    file: 'File',
    fileError: 'File error',
  },
  lock: {
    limit: 'Message sending restricted',
    unavailable: 'Chat unavailable',
    banIntro: 'Admin restricted you from sending messages.',
    banCanWritePrefix: 'You can send messages again on',
    chatClosed: 'Chat closed.',
    newDialog: 'Start new chat',
    afterTime: 'after',
  },
  dates: {
    today: 'today',
    yesterday: 'yesterday',
  },
};
